import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../lib/api';
import { fetchJson } from '../../lib/apiFetchJson';
import { FlowIdentityResponseSchema, type FlowIdentity } from '@shared/flow/identity';

/**
 * The acting user's Flow role + display name (GET /api/flow/identity) —
 * feeds Command Center's role-based default filters (roleDefaults.ts).
 * Cached indefinitely: identity doesn't change mid-session, and impersonation
 * switches reload the app rather than swapping the acting user in place.
 */
export function useFlowIdentity() {
  const { apiFetch } = useApi();

  return useQuery<FlowIdentity | null>({
    queryKey: ['flow-identity'],
    staleTime: Infinity,
    // Identity is a silent default-filter seed: no toast when it fails.
    meta: { suppressErrorToast: true },
    queryFn: async () => {
      const data = await fetchJson(apiFetch, FlowIdentityResponseSchema, '/api/flow/identity');
      return data.identity ?? null;
    },
  });
}
